import { useEffect } from "react";
import { setCanonical, setMetaTags, SpeakableSchema } from "@/components/seo/SchemaMarkup";

export default function CookiePolicyPage() {
  useEffect(() => {
    setCanonical("/cookie-policy");
    setMetaTags({ title: "Cookie Policy | Storajini Guide", description: "Cookie Policy for Storajini Guide - how we use cookies and tracking technologies." });
  }, []);

  return (
    <div data-testid="cookie-policy-page">
      <SpeakableSchema selectors={["h1"]} />
      <div className="py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-8">Cookie Policy</h1>
        <div className="prose max-w-none space-y-6 text-gray-600 leading-relaxed">
          <p><strong>Last updated:</strong> March 2026</p>

          <p>This Cookie Policy explains how Storajini Guide (storajini.net) uses cookies and similar technologies to recognize you when you visit our website.</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">What Are Cookies?</h2>
          <p>Cookies are small data files placed on your device when you visit a website. They are widely used to make websites work efficiently, provide analytics information, and enable personalized experiences.</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Types of Cookies We Use</h2>

          <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Essential Cookies</h3>
          <p>These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas. The website cannot function properly without these cookies.</p>

          <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Analytics Cookies</h3>
          <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website and content.</p>

          <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Functional Cookies</h3>
          <p>These cookies enable enhanced functionality and personalization, such as remembering your preferences (e.g., cookie consent choice, chat history with Sarah).</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">How to Manage Cookies</h2>
          <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>View what cookies are stored and delete them individually</li>
            <li>Block third-party cookies</li>
            <li>Block cookies from specific sites</li>
            <li>Block all cookies</li>
            <li>Delete all cookies when you close your browser</li>
          </ul>
          <p>Please note that blocking certain cookies may impact the functionality of our website.</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Third-Party Cookies</h2>
          <p>We may use third-party services that set their own cookies, including analytics services. These third parties have their own privacy policies governing the use of cookies.</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Compliance</h2>
          <p>This cookie policy complies with the Philippines Data Privacy Act (RA 10173), the EU General Data Protection Regulation (GDPR), and the California Consumer Privacy Act (CCPA). We obtain your consent before placing non-essential cookies on your device.</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
          <p>If you have questions about our use of cookies, please contact us at support@storajini.com.</p>
        </div>
      </div>
      </div>
    </div>
  );
}
